
import XInput from 'vux/src/components/x-input/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Picker from 'vux/src/components/picker/index.vue'
import Popup from 'vux/src/components/popup/index.vue'
import XDialog from 'vux/src/components/x-dialog/index.vue'

import Dator from "@/utils/censor.js";
import loginFun from "@/utils/cc-webapp/login.js";
import DragRightCaptcha from "@/components/DragRightCaptcha";
export default {
name: "login",
components: {
XInput,
Group,
Picker,
Popup,
XDialog,
DragRightCaptcha
},
data() {
return {
iconNone: require("@/assets/image/icon/dele.png"),
iconAll: {
iconLogo: require("@/assets/image/icon/logo.png"),
wechatLogo: require("@/assets/image/icon/wechat_logo.png"),
facebookLogo: require("@/assets/image/icon/facebook_logo.png"),
googleLogo: require("@/assets/image/icon/google_logo.png"),
arrow: require("@/assets/image/icon/arrow.png")
},
area: [
[
{ name: this.$t('LOGIN_LANG.area.0'), value: "+86" },
{ name: this.$t('LOGIN_LANG.area.1'), value: "+852" },
{ name: this.$t('LOGIN_LANG.area.2'), value: "+853" }
]
],
selectArea: ["+852"], //選擇器默認選擇
phoneArea: "+852", //頁面顯示
popupFlag: false, //區域號碼選擇彈窗
showType: true, //true電郵登錄  false手機登錄,
phoneNum: "",
second: 0, //倒計時
code: "",
passw: "",
email: "",
BayDialog: false, //綁定完成彈窗
codeSended: false,
sendCodeFlag: false ,//驗證碼發送過程，避免多次點擊
isLogin: false,
session: '',
userInfo: '',
isGetPage: false,
captchaVisible: false,
captchaId: "",
pendingPostD: null,
};
},
methods: {

onClickLeft(){
this.$router.go(-1)
},

selectPhone(idx) {
this.phoneArea = this.area[0][idx].value;

this.popupFlag = !this.popupFlag;
},

showArea() {
this.popupFlag = !this.popupFlag;
},

changeArea() {
this.popupFlag = !this.popupFlag;
this.phoneArea = this.selectArea[0];
},


getTelVerificationCode() {
if (this.second > 0) {
this.$utils.showToast(this.$t('BINDPHONE_LANG.sendTime'));
return;
}


let dator = new Dator.dator();

dator.add(this.phoneNum, [
{ strategy: "isEmpty", errMsg: this.$t('BINDPHONE_LANG.inputPhone')}
]);

if (this.phoneArea === "+852" || this.phoneNum === "+853") {

dator.add(this.phoneNum, [
{ strategy: "checkNumber", errMsg: this.$t('BINDPHONE_LANG.phoneNumberErr')},
{
strategy: "checkStringFormat:8:1",
errMsg: this.$t('BINDPHONE_LANG.macaoPhoneErr')
}
]);
}

if (this.phoneArea === "+86") {

dator.add(this.phoneNum, [
{ strategy: "checkNumber", errMsg: this.$t('BINDPHONE_LANG.phoneNumberErr')},
{
strategy: "checkStringFormat:11:1",
errMsg: this.$t('BINDPHONE_LANG.zhPhoneErr')
},
{ strategy: "checkPhone", errMsg: this.$t('BINDPHONE_LANG.phoneInputErr') }
]);
}

if (dator.getErrmsg()) {
let text = dator.getErrmsg();

this.$utils.showToast(text);

return;
}

this.pendingPostD = {
area: this.phoneArea,
phone: this.phoneNum,
type: 1
};

this.sendCodeFlag = true;
this.GLOBAL_.ccRequest.doAxios(this.CONFIG.USER.DRAG_RIGHT_CAPTCHA_CREATE, {}, "POST")
.then(res => {
this.captchaId = res.data.captchaId;
this.sendCodeFlag = false;
this.captchaVisible = true;
})
.catch(() => {
this.sendCodeFlag = false;
this.$utils.showToast("驗證碼初始化失敗，請重試");
});
},
onCaptchaSolved({ finalPercent, track }) {
this.captchaVisible = false;
let postD = Object.assign({}, this.pendingPostD, {
captchaId: this.captchaId,
finalPercent: finalPercent,
track: track,
});
this.GLOBAL_.ccRequest.doAxios(this.CONFIG.USER.TELVERIFICATIONCODE, postD, "POST")
.then(res => {
this.codeSended = true;
this.second = 60;
this.$utils.showToast(this.$t('BINDPHONE_LANG.codeSend'));
this.startCounting();
})
.catch(err => {
let res = err && err.response;
let msg = res && res.data && res.data.message;
this.$utils.showToast(this.$t('FORGET_LANG.getCodeErr') + "：" + (msg || ""));
});
},
startCounting() {
let _this = this;

if (this.second > 0) {
setTimeout(() => {
_this.second -= 1;
_this.startCounting();
}, 1000);
}
},

dobindPhone() {
let dator = new Dator.dator();
dator.add(this.code, [
{ strategy: "isEmpty", errMsg: this.$t('FORGET_LANG.inputCode') },
{ strategy: "checkStringFormat:4:1", errMsg: this.$t('LOGIN_LANG.codeErr') }
]);

if (dator.getErrmsg()) {
this.$utils.showToast(dator.getErrmsg());
return;
}

let postD = {
area: this.phoneArea,
phone: this.phoneNum,
code: this.code
};
console.log('postD', postD)

this.GLOBAL_.ccRequest.doSessionAxios(this.CONFIG.USER.BINDPHONE, postD, "POST", false, this.$route.query.session)
.then(res => {
console.log('绑定成功', res, this.isGetPage)
this.BayDialog = false;
this.$utils.showToast(this.$t('BINDPHONE_LANG.bindSuccess'));

if (this.isGetPage) {

let obj = this.session;
obj["userInfo"] = this.userInfo;
loginFun.saveLoginSession(obj);

setTimeout(() => {
this.$toast.close();
this.$router.push({
path: '/my'
})
}, 500);
} else {

setTimeout(() => {
this.$toast.close();
this.$router.back()
}, 500);

}

})
.catch(err => {
let res = err.response;
this.$utils.showToast(this.$t('BINDEMAIL_LENG.bindFail')+":" + res.data.message);
});
}
},
mounted: function() {
let getPage = this.$route.query.getPage;
if (getPage) {
this.isGetPage = true;
}
this.LOGIN2.getSession("no login")
.then(session => {
console.log("session", session);

this.isGetPage = false;
})
.catch(err => {
console.log("沒有session", err);
this.session = this.$route.query.session;
this.userInfo = this.$route.query.userInfo;
});
},
created() {}
};



// WEBPACK FOOTER //
// ./src/pages/me/bindPhone.vue